import styled from "styled-components";

export const SettingsGroup = styled.div`
  padding: 0.5rem;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 0.75rem;
  font-weight: 500;
`;

export const SettingsGroupLabel = styled.label`
  width: 100%;
`;
